export default __webpack_public_path__ + "static/media/registration_logo.70eed7bd.png";